import OpComponentsDischargeManager from './OpComponentsDischargeManager';

export default {
  OpComponentsDischargeManager,
};
